<template>
  <div class="card mb-4">
    <div class="card-content no-padding">
      <div v-if="!isPageLoaded" id="loader">
        <BLoading :active="!isPageLoaded" :is-full-page="false">
          <div class="is-syncing-loader has-text-weight-bold is-size-1">
            Loading&hellip;
          </div>
        </BLoading>
      </div>

      <div class="columns">
        <div class="column">
          <WtLabel
            text="Minimum Supported Build #"
            label-for="minVersion"
            position="is-right"
            required
            :tooltip-text="minVersionTooltip"
          />
          <BInput
            id="minVersion"
            ref="minVersion"
            v-model="minVersion"
            v-validate="'required|integer|lt:targetVersion'"
            data-vv-delay="300"
            name="minVersion"
            type="text"
            placeholder="Min supported build #"
          />
          <div>{{ errors.first("minVersion") }}</div>
        </div>
        <div class="column">
          <WtLabel
            text="Target Build #"
            label-for="targetVersion"
            position="is-right"
            required
            :tooltip-text="targetVersionTooltip"
          />
          <BInput
            id="targetVersion"
            ref="targetVersion"
            v-model="targetVersion"
            v-validate="'required|integer|gt:minVersion'"
            data-vv-delay="300"
            type="text"
            name="targetVersion"
            placeholder="Target build #"
          />
          <div>{{ errors.first("targetVersion") }}</div>
        </div>
        <div class="column">
          <br />
          <BField :message="processingUpdate ? 'Processing' : ''">
            <WtButton
              bold
              color="primary"
              size="large"
              :loading="processingUpdate"
              @click.native="saveChanges"
            >
              SAVE
            </WtButton>
          </BField>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import WtButton from "@@/WtButton/WtButton.vue";
import WtLabel from "@@/WtLabel/WtLabel.vue";

export default {
  name: "MobileSupportForm",
  components: { WtLabel, WtButton },

  props: {
    platform: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      isPageLoaded: false,
      processingUpdate: false,
      minVersion: "0",
      targetVersion: "0",
      minVersionTooltip: `This is the oldest build version we support.`,
      targetVersionTooltip: `This is the latest build version we support.`
    };
  },

  mounted() {
    let resp = this.getMobileVersionInfoByPlatform(this.$props.platform);

    resp
      .then(d => {
        this.isPageLoaded = true;
        this.minVersion = d.minVersion;
        this.targetVersion = d.targetVersion;
      })
      .catch(() => {
        this.snackBar({
          duration: 10000,
          type: "is-danger",
          message: "Failed to load mobile version data."
        });
      });
  },

  methods: {
    ...mapActions("mobileSupport", [
      "getMobileVersionInfoByPlatform",
      "updateAppSupport"
    ]),
    ...mapActions(["snackBar"]),
    async saveChanges() {
      const validates = await this.$validator.validateAll();
      this.processingUpdate = true;

      const payload = {
        platform: this.$props.platform,
        minSupportedVersion: this.minVersion,
        targetVersion: this.targetVersion
      };

      if (!validates) {
        this.processingUpdate = false;
        return;
      }

      this.updateAppSupport(payload)
        .then(response => {
          if (response.status === 200 && response.data.success) {
            this.snackBar({
              duration: 3000,
              type: "is-success",
              message: "Mobile version settings saved successfully."
            });
            this.processingUpdate = false;
          } else {
            this.snackBar({
              duration: 10000,
              type: "is-danger",
              message: response.data.message || "Failed to save changes."
            });
            this.processingUpdate = false;
          }
        })
        .catch(error => {
          this.snackBar({
            duration: 5000,
            type: "is-danger",
            message: error.response?.data?.message || "Failed to save changes."
          });
          this.processingUpdate = false;
        });
    }
  }
};
</script>
